/* eslint-disable */
<template>
  <div>
    <!-- Navbar start -->
    <navbar-element></navbar-element>
    <!-- Navbar end -->

    <!-- Rendered view start -->
    <div class="mt-[0px]">
      <router-view></router-view>
    </div>

    <!-- Rendered view end -->

    <!-- Footer start -->
    <footer-element></footer-element>
    <!-- Footer end -->
  </div>
</template>

<script>
import NavbarElement from "@/components/NavbarElement.vue";
import FooterElement from "@/components/FooterElement.vue";
// import VueMeta from "vue-meta";
// import HomeView from '@/HomeView.vue';

export default {
  components: {
    // HomeView,
    FooterElement,
    NavbarElement,
  },
  metaInfo: {
    title: "Rehabilitation Centre in Nakuru, Kenya",
    meta: [
      {
        name: "description",
        content:
          "Find compassionate addiction recovery in Nakuru at Triple Palm. Rehabilitation centre in nakuru. Rehabilitation centre in Kenya. Recovery. Alcoholism",
      },
      {
        name: "keywords",
        content:
          "rehab, recovery, drug abuse, alcoholism, Nakuru, rehabilitation, drugs, addiction",
      },
    ],
  },
};
</script>

<style></style>
